import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../context/Language";

// A Link that keeps the current language prefix. Use it for every internal
// link, so a visitor reading in French never falls back to English.
const LocaleLink = ({ to, children, ...rest }) => {
  const { localePath } = useLanguage();
  return (
    <Link to={localePath(to)} {...rest}>
      {children}
    </Link>
  );
};

export default LocaleLink;
